import { render, staticRenderFns } from "./RefsLeadGroup.vue?vue&type=template&id=5596472c"
import script from "./RefsLeadGroup.vue?vue&type=script&lang=ts"
export * from "./RefsLeadGroup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports